import { useLocation } from 'react-router-dom'
import { DashboardTypes } from 'features/Codes'
import { parse } from 'query-string'

export const DASHBOARD_REFERRER = {
  CAMPAIGN: DashboardTypes.CAMPAIGN,
  AD_GROUP: DashboardTypes.AD_GROUP,
  KEYWORD: DashboardTypes.KEYWORD,
  CREATIVE: DashboardTypes.CREATIVE,
}

const useDashboardReferrer = () => {
  const { search } = useLocation()
  const { from } = parse(search)
  return from
}

export default useDashboardReferrer
